<template>
  <div class="ds-page">
    <!-- Tabs + Tambah -->
    <div class="ds-tabs">
      <button class="ds-tab" :class="{ active: tab === 'oil' }" @click="tab = 'oil'">Oil Maker</button>
      <button class="ds-tab" disabled>Label Maker</button>
      <!-- <span class="ds-soon">Coming Soon</span> -->
      <!-- <span class="ds-reminder-note flex-grow-1 ml-2">
        Reminders are emailed to the main PIC, with CC/BCC copies if provided.
      </span> -->
      <button class="ds-btn ds-btn-primary" style="margin-left: auto;" @click="openAdd">Tambah</button>
    </div>

    <div class="ds-card">
      <table class="ds-table">
        <thead>
          <tr>
            <th>Plant</th>
            <th>Main PIC</th>
            <th>Email</th>
            <th>Email copy (CC)</th>
            <th>Blind copy (BCC)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td colspan="6" class="text-center ds-muted">Loading...</td>
          </tr>
          <template v-else>
            <tr v-for="c in list" :key="c.code">
              <td><b>{{ c.code }}</b><span class="ds-sub">{{ c.region || "—" }}</span></td>
              <td>
                <span v-if="c.pic">{{ c.pic }}</span>
                <span v-else class="text-danger">Not set</span>
              </td>
              <td v-for="k in ['emails', 'cc', 'bcc']" :key="k" :class="{ 'ds-muted': k !== 'emails' }">
                <template v-if="c[k].length">
                  {{ c[k][0] }}
                  <span v-if="c[k].length > 1" class="more">+{{ c[k].length - 1 }}
                    <span class="more-box"><span v-for="e in c[k]" :key="e">{{ e }}</span></span>
                  </span>
                </template>
                <template v-else>—</template>
              </td>
              <td class="num"><button class="ds-btn" @click="openEdit(c)">Edit</button></td>
            </tr>
            <tr v-if="!list.length">
              <td colspan="6" class="text-center ds-muted">No contacts available.</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <!-- Modal -->
    <div v-if="modal" class="ds-modal-bg" @mousedown.self="closeModal">
      <div class="ds-modal">
        <div class="ds-modal-head">
          <div>
            <h4 class="ds-modal-title">{{ form.code ? "Edit Contact · " + form.code : "Add Contact" }}</h4>
            <small class="ds-modal-subtitle">
              {{ tab === "oil" ? "Oil Maker" : "Label Maker" }}
              <template v-if="form.region"> · {{ form.region }}</template>
            </small>
          </div>
          <button class="ds-x" @click="closeModal">×</button>
        </div>
        <div class="ds-modal-body">
          <div class="ds-required-star mb-3" style="font-size: 12px; color: #F92A2A;">* required</div>

          <template v-if="!lockCode">
            <label class="ds-label">Plant <span class="ds-required-star">*</span></label>
            <select class="ds-input" :class="{ 'is-error': errors.code }" v-model="form.code" @change="$delete(errors, 'code')">
              <option value="" disabled>Select plant</option>
              <option v-for="u in unsetList" :key="u.code" :value="u.code">{{ u.code }}</option>
            </select>
            <div class="ds-hint" :class="{ 'text-danger': errors.code }">{{ errors.code || "Only plants without contacts are listed" }}</div>
          </template>

          <label class="ds-label">Region <span class="ds-required-star">*</span></label>
          <input class="ds-input" :class="{ 'is-error': errors.region }" v-model.trim="form.region" placeholder="e.g. Cikarang" @blur="checkRequired('region')" />
          <div class="ds-hint" :class="{ 'text-danger': errors.region }">{{ errors.region || "Plant location, shown under the plant name in the list" }}</div>

          <label class="ds-label">Main PIC name <span class="ds-required-star">*</span></label>
          <input class="ds-input" :class="{ 'is-error': errors.pic }" v-model.trim="form.pic" placeholder="Enter PIC name" @blur="checkRequired('pic')" />
          <div class="ds-hint" :class="{ 'text-danger': errors.pic }">{{ errors.pic }}&nbsp;</div>

          <div v-for="f in fields" :key="f.key">
            <label class="ds-label">{{ f.label }}<span v-if="f.key === 'emails'" class="ds-required-star">*</span></label>
            <div class="ds-tags" :class="{ 'is-error': errors[f.key] }">
              <span v-for="(e, i) in form[f.key]" :key="e" class="ds-tag" :class="{ invalid: !isValid(e) }">
                {{ e }}<a @click="removeTag(f.key, i)">×</a>
              </span>
              <input v-model="drafts[f.key]" :placeholder="form[f.key].length ? 'Add email...' : f.placeholder"
                @keydown.enter.prevent="addTag(f.key)" @keydown.188.prevent="addTag(f.key)"
                @paste.prevent="onPaste($event, f.key)" @blur="onBlur(f.key)" />
            </div>
            <div class="ds-hint" :class="{ 'text-danger': errors[f.key] }">{{ errors[f.key] || f.hint }}</div>
          </div>
        </div>
        <div class="ds-modal-foot">
          <button class="ds-btn ds-btn-danger-o" :disabled="saving" @click="closeModal">Cancel</button>
          <button class="ds-btn ds-btn-primary" :disabled="saving" @click="save">{{ saving ? "Saving..." : "Save" }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const blank = () => ({ id: null, code: "", region: "", pic: "", emails: [], cc: [], bcc: [] });
const ENDPOINTS = {
  oil: "/api/data-submission/oil-maker/recipients",
  label: null,
};

export default {
  name: "RecipientContacts",
  data() {
    return {
      tab: "oil",
      loading: false,
      saving: false,
      modal: false,
      mode: "create",
      lockCode: false,
      errors: {},
      form: blank(),
      drafts: { emails: "", cc: "", bcc: "" },
      list: [],
      fields: [
        { key: "emails", label: "Email", placeholder: "name@company.co.id", hint: "You can add more than 1 email. Press Enter or comma to add an email." },
        { key: "cc", label: "Email copy (CC)", placeholder: "Enter email (optional)", hint: "CC recipients are visible to the PIC. Press Enter or comma to add an email." },
        { key: "bcc", label: "Blind copy (BCC)", placeholder: "Enter email (optional)", hint: "BCC recipients are hidden from the PIC and CC. Press Enter or comma to add an email." },
      ],
    };
  },
  computed: {
    endpoint() { return ENDPOINTS[this.tab]; },
    unsetList() { return this.list.filter((c) => !c.isSet); },
  },
  watch: {
    tab() { this.fetchList(); },
  },
  mounted() { this.fetchList(); },
  methods: {
    // ---------- API ----------
    async fetchList() {
      this.list = [];
      if (!this.endpoint) return;
      this.loading = true;
      try {
        const res = await this.$http.get(this.endpoint);
        this.list = (res.data.data || []).map((d) => ({
          id: d.id,
          code: d.oil_maker_code,
          region: d.region,
          pic: d.main_pic_name,
          emails: d.email || [],
          cc: d.cc_email || [],
          bcc: d.bcc_email || [],
          isSet: !!d.is_contact_set,
        }));
      } catch (err) {
        this.notify("error", "Failed to load contacts", err);
      } finally {
        this.loading = false;
      }
    },
    async save() {
      this.errors = {};
      ["emails", "cc", "bcc"].forEach((k) => this.addTag(k));
      ["region", "pic"].forEach((k) => this.checkRequired(k));
      if (!this.form.code) this.$set(this.errors, "code", "Required");
      if (!this.form.emails.length && !this.errors.emails) this.$set(this.errors, "emails", "Required");
      if (Object.keys(this.errors).length) return;

     const payload = {
        oil_maker_code: this.form.code,
        region: this.form.region,
        main_pic_name: this.form.pic,
        email: this.form.emails.join(","),
        ...(this.form.cc.length && { cc_email: this.form.cc.join(",") }),
        ...(this.form.bcc.length && { bcc_email: this.form.bcc.join(",") }),
      };
      this.saving = true;
      try {
        if (this.mode === "create") await this.$http.post(this.endpoint, payload);
        else await this.$http.put(`${this.endpoint}/${this.form.id}`, payload);
        this.modal = false;
        await this.fetchList();
        this.notify("success", "Saved");
      } catch (err) {
        const d = err.response && err.response.data && err.response.data.data;
        if (d && typeof d === "object") {
          const map = { email: "emails", cc_email: "cc", bcc_email: "bcc" };
          const fieldErrors = {};
          Object.keys(map).forEach((k) => {
            if (!d[k]) return;
            fieldErrors[map[k]] = typeof d[k] === "string"
              ? d[k]
              : `${d[k].message}: ${(d[k].emails || []).join(", ")}`;
          });
          if (Object.keys(fieldErrors).length) { this.errors = fieldErrors; return; }
        }
        this.notify("error", "Failed to save", err);
      } finally {
        this.saving = false;
      }
    },
    notify(icon, title, err) {
      if (!this.$swal) return;
      const text = err && err.response && err.response.data && err.response.data.message;
      this.$swal.fire({ title, text, icon, timer: icon === "success" ? 1200 : undefined, showConfirmButton: icon !== "success" });
    },
    // ---------- Modal ----------
    openAdd() {
      this.mode = "create";
      this.lockCode = false;
      this.form = blank();
      this.openModal();
    },
    openEdit(c) {
      this.mode = c.isSet ? "edit" : "create"; // plant yang belum diatur -> POST
      this.lockCode = true;
      this.form = { id: c.id, code: c.code, region: c.region || "", pic: c.pic || "", emails: [...c.emails], cc: [...c.cc], bcc: [...c.bcc] };
      this.openModal();
    },
    openModal() {
      this.errors = {};
      this.drafts = { emails: "", cc: "", bcc: "" };
      this.modal = true;
    },
    closeModal() { if (!this.saving) this.modal = false; },
    // ---------- Validasi & chip email ----------
    isValid(e) { return EMAIL_RE.test(e); },
    checkRequired(field) {
      if (!this.form[field]) this.$set(this.errors, field, "Required");
      else this.$delete(this.errors, field);
    },
    refreshError(key, dup = false) {
      const msg = dup
        ? "Email already added"
        : this.form[key].some((e) => !EMAIL_RE.test(e)) ? "Invalid email format" : "";
      if (msg) this.$set(this.errors, key, msg);
      else this.$delete(this.errors, key);
    },
    addTag(key) {
      let dup = false;
      this.drafts[key].split(/[,;\s]+/).filter(Boolean).forEach((e) => {
        if (this.fields.some((f) => this.form[f.key].includes(e))) dup = true; // duplikat dalam/antar field
        else this.form[key].push(e);
      });
      this.drafts[key] = "";
      this.refreshError(key, dup);
    },
    removeTag(key, i) {
      this.form[key].splice(i, 1);
      this.refreshError(key);
    },
    onPaste(e, key) {
      this.drafts[key] += (e.clipboardData || window.clipboardData).getData("text");
      this.addTag(key);
    },
    onBlur(key) {
      this.addTag(key);
      if (key === "emails" && !this.form.emails.length && !this.errors.emails) this.$set(this.errors, "emails", "Required");
    },
  },
};
</script>

<style src="./ds-common.css"></style>
<style scoped>
.ds-tab:disabled { cursor: not-allowed; color: #C4CBCD; }
.ds-soon { margin-left: 6px; padding: 1px 6px; border-radius: 8px; background: #EDF1F2; font-size: 10px; color: #9aa4ad; }
.ds-input.is-error, .ds-tags.is-error { border-color: #F92A2A; }
.ds-tag.invalid { background: #FDE8E8; color: #CD2E2C; }
.ds-tag.invalid a { color: #CD2E2C; }
.more { position: relative; margin-left: 6px; padding: 1px 7px; border-radius: 10px; background: #EDF1F2; font-size: 11px; cursor: default; }
.more-box { display: none; position: absolute; left: 0; top: 22px; z-index: 20; background: #fff; color: #555; box-shadow: 0 2px 10px rgba(0,0,0,.18); border-radius: 4px; padding: 8px 12px; white-space: nowrap; font-size: 11px; }
.more-box span { display: block; line-height: 1.6; }
.more:hover .more-box { display: block; }
</style>